import styled from 'styled-components';

export const StyledNotSupportedView = styled.div`
  width: 100%;
  text-align: center;
  font-size: 1.2em;
`;
